import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedData } from '../../shared/sharedData'

@Component({
  selector: 'emailPreview',
  templateUrl: 'emailPreview.html'
})
export class EmailPreview {

  public localState: any;
  public emailData:any;
  constructor(
    public route: ActivatedRoute,
    public activeModal: NgbActiveModal,
    public share: SharedData,
  ) { 
    let self = this;
    self.emailData = self.share.getData();
    console.log("Mail data::",self.emailData);
  }
}



// WEBPACK FOOTER //
// ./src/app/programManagement/emailNotification/emailPreview.ts